module.exports = __webpack_public_path__ + "static/ballerinahamper-57fe182c1c0cb389fc6dc845b1341630.jpeg";